import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import type { FormNames } from '../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    ProjectUserGroupPropertyValidation,
    type ProjectUserGroupResource,
} from '../../../../resource/resources/persistables/user/projectUserGroupResource';
import { ArrayInputs } from '../../../reusable-components/base/property-bases/ArrayInputs';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';

export const ProjectUserGroupUsersTabContent = ({
    form,
    formNames,
    id,
    parentId,
}: {
    form: UseFormReturn<ProjectUserGroupResource>;
    formNames: FormNames<ProjectUserGroupResource>;
    id: string | undefined;
    parentId: string;
}) => {
    return (
        <Grid>
            <Grid.Col span={12}>
                <ArrayInputs.ProjectUserGroup_Array
                    parentId={parentId}
                    form={form}
                    readOnly={false}
                    name={formNames.projectUserGroups}
                    label={'Project User Groups Assigned'}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <ArrayInputs.User_Array form={form} readOnly={false} name={formNames.users} label={'Users Assigned'} />
            </Grid.Col>
            <Grid.Col span={12}>
                <ArrayInputs.SystemUserGroup_Array
                    form={form}
                    readOnly={false}
                    name={formNames.systemUserGroups}
                    label={'System User Groups Assigned'}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <PropertyInputs.String
                    nullable={true}
                    control={form.control}
                    name={formNames.userWildcardMatcher}
                    readOnly={false}
                    propertyValidationInformation={{
                        resourceType: ResourceType.PROJECT_USER_GROUP,
                        resourceId: id,
                        propertyIdentifier: ProjectUserGroupPropertyValidation.USER_WILDCARD_MATCHER,
                    }}
                />
            </Grid.Col>
        </Grid>
    );
};
